import React, { Component } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons'

class Header extends Component {
    componentDidMount = () => {}

    sideBarControl = (e) => {e.preventDefault();
        let event = e.currentTarget.getAttribute('data-event')
        var body = document.body
        let sidebar = document.getElementById('sidebar-section')
        if (event === 'close') {
            body.classList.add("sidebar-collapse");
            sidebar.classList.add('animate-menu-left')
            e.currentTarget.setAttribute('data-event', 'open')
        } else {
            body.classList.remove("sidebar-collapse");
            sidebar.classList.remove('animate-menu-left')
            e.currentTarget.setAttribute('data-event', 'close')
        }
    }

    render() {
        return (
            <div>
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link toggleSideMenu" id="toggleSideMenu" data-event="close" data-widget="pushmenu" to="#" role="button" onClick={ this.sideBarControl.bind(this)}><FontAwesomeIcon icon={ faBars } /></Link >
                        </li>
                        <li className="nav-item d-none d-sm-inline-block">
                            <NavLink to="/dashboard" className="nav-link">Home</NavLink >
                        </li>
                    </ul>
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item d-none d-sm-inline-block">
                            <NavLink to="/login" className="nav-link"><FontAwesomeIcon icon={faSignOutAlt} /> Log Out</NavLink >
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }
}

export default Header